<div class="user-account-management">
  <!-- Header with buttons -->
  <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
    <h5 class="mb-0">
      <i class="bi bi-building me-2"></i>
      {{ 'SystemAdmin.userAccountManagement' | translate }}
    </h5>
    
    <button type="button" class="btn btn-primary btn-sm" (click)="openCreateModal()">
      <i class="bi bi-plus-circle me-1"></i>
      {{ 'SystemAdmin.addUserAccount' | translate }}
    </button>
  </div>

  <!-- Smart Grid -->
  <div class="row" *ngIf="columns.length > 0">
    <div class="col-12">
      <konti-smart-grid 
        [data]="userAccounts?.rows || []" 
        [columns]="columns" 
        [initialSort]="[{ field: 'fullName', dir: 'asc' }]"
        [showGroupPanel]="false"
        [showFilterTypePanel]="true">
        
        <!-- Actions column -->
        <ng-template appSmartGridCell="actions" let-row>
          <div class="action-capsule btn-group btn-group-sm sg-desktop-only">
            <button type="button" class="btn btn-outline-secondary" 
                    (click)="openEditModal(row)"
                    [title]="'General.edit' | translate">
              <i class="bi bi-pencil" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'General.edit' | translate }}</span>
            </button>
            <button type="button" class="btn btn-outline-danger action-danger" 
                    (click)="openDeleteModal(row)"
                    [title]="'General.delete' | translate">
              <i class="bi bi-trash3" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'General.delete' | translate }}</span>
            </button>
          </div>
        </ng-template>
      </konti-smart-grid>
    </div>
  </div>
</div>

<!-- User Account Modal (Create/Edit) -->
<ng-template #userAccountModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-building me-2"></i>
      {{ (isEditing ? 'SystemAdmin.editUserAccount' : 'SystemAdmin.addUserAccount') | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="userAccountForm">
      <!-- Full Name -->
      <div class="mb-3">
        <label class="form-label">
          {{ 'SystemAdmin.fullName' | translate }} <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="fullName" maxlength="100"
               placeholder="Acme Corporation AS"
               [class.is-invalid]="f['fullName'].invalid && f['fullName'].touched" />
        <div class="invalid-feedback" *ngIf="f['fullName'].invalid && f['fullName'].touched">
          {{ 'General.required' | translate }}
        </div>
      </div>

      <!-- Address Information -->
      <h6 class="border-bottom pb-2 mb-3">{{ 'SystemAdmin.addressInformation' | translate }}</h6>
      
      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.address' | translate }}</label>
        <input type="text" class="form-control" formControlName="address" maxlength="50"
               [class.is-invalid]="f['address'].invalid && f['address'].touched" />
        <div class="invalid-feedback" *ngIf="f['address'].invalid && f['address'].touched">
          {{ 'SystemAdmin.addressTooLong' | translate }}
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.address2' | translate }}</label>
        <input type="text" class="form-control" formControlName="address2" maxlength="50"
               [class.is-invalid]="f['address2'].invalid && f['address2'].touched" />
        <div class="invalid-feedback" *ngIf="f['address2'].invalid && f['address2'].touched">
          {{ 'SystemAdmin.addressTooLong' | translate }}
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label class="form-label">{{ 'SystemAdmin.zipCode' | translate }}</label>
            <input type="text" class="form-control" formControlName="zipCode" maxlength="6"
                   [class.is-invalid]="f['zipCode'].invalid && f['zipCode'].touched" />
            <div class="invalid-feedback" *ngIf="f['zipCode'].invalid && f['zipCode'].touched">
              {{ 'SystemAdmin.zipCodeTooLong' | translate }}
            </div>
          </div>
        </div>
        
        <div class="col-md-8">
          <div class="mb-3">
            <label class="form-label">{{ 'SystemAdmin.city' | translate }}</label>
            <input type="text" class="form-control" formControlName="city" maxlength="30"
                   [class.is-invalid]="f['city'].invalid && f['city'].touched" />
            <div class="invalid-feedback" *ngIf="f['city'].invalid && f['city'].touched">
              {{ 'SystemAdmin.cityTooLong' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Information -->
      <h6 class="border-bottom pb-2 mb-3">{{ 'SystemAdmin.contactInformation' | translate }}</h6>
      
      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.email' | translate }}</label>
        <input type="email" class="form-control" formControlName="email" maxlength="100"
               placeholder="contact@acme.no"
               [class.is-invalid]="f['email'].invalid && f['email'].touched" />
        <div class="invalid-feedback" *ngIf="f['email'].invalid && f['email'].touched">
          <span *ngIf="f['email'].errors?.['email']">{{ 'SystemAdmin.invalidEmail' | translate }}</span>
          <span *ngIf="f['email'].errors?.['maxlength']">{{ 'SystemAdmin.emailTooLong' | translate }}</span>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">{{ 'SystemAdmin.phone' | translate }}</label>
        <input type="tel" class="form-control" formControlName="phone" maxlength="12"
               placeholder="+4712345678"
               [class.is-invalid]="f['phone'].invalid && f['phone'].touched" />
        <div class="invalid-feedback" *ngIf="f['phone'].invalid && f['phone'].touched">
          {{ 'SystemAdmin.phoneTooLong' | translate }}
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="saveUserAccount()"
            [disabled]="userAccountForm.invalid">
      <i class="bi bi-save me-1"></i>
      {{ 'General.save' | translate }}
    </button>
  </div>
</ng-template>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h5 class="modal-title">
      <i class="bi bi-exclamation-triangle me-2"></i>
      {{ 'SystemAdmin.confirmDeleteUserAccount' | translate }}
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closeModal()"></button>
  </div>
  
  <div class="modal-body">
    <p>{{ 'SystemAdmin.deleteUserAccountWarning' | translate }}</p>
    <div *ngIf="userAccountToDelete" class="alert alert-info">
      <strong>{{ userAccountToDelete.fullName }}</strong>
      <div *ngIf="userAccountToDelete.email" class="text-muted small">
        <i class="bi bi-envelope me-1"></i>{{ userAccountToDelete.email }}
      </div>
    </div>
    <div *ngIf="deleteDomainCount > 0" class="alert alert-danger">
      <i class="bi bi-exclamation-triangle me-2"></i>
      <strong>{{ 'SystemAdmin.cannotDelete' | translate }}:</strong><br />
      {{ deleteDomainCount }} {{ 'SystemAdmin.domainCount' | translate | lowercase }}
    </div>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()"
            [disabled]="deleteDomainCount > 0">
      <i class="bi bi-trash3 me-1"></i>
      {{ 'General.delete' | translate }}
    </button>
  </div>
</ng-template>
